// extracted by mini-css-extract-plugin
export default {"table":"style_table__AEHIu","tableCellHead":"style_tableCellHead__YnFQt","tableCell":"style_tableCell__tdDDY"};